import {RegrasDeAgendamentoDeProduto} from "../../../../server/domain/RegrasDeAgendamentoDeProduto";

/**
 * Decide o que fazer quando o cliente tenta colocar um produto na sacola, considerando
 * o agendamento que a sacola já tem (a data vale para o pedido inteiro).
 *
 *  - adicionar:   entra direto (disponível agora, ou disponível na data já agendada)
 *  - agendar:     produto fora do dia de hoje e sacola sem data: abrir o agendamento
 *  - trocarData:  sacola agendada num dia em que o produto não existe, mas há dia bom para todos
 *  - incompativel: nenhum dia serve para o produto novo e para os itens que já estão na sacola
 */
export type AcaoAoAdicionar = 'adicionar' | 'agendar' | 'trocarData' | 'incompativel';

export interface AvaliacaoAdicao {
  acao: AcaoAoAdicionar;
  mensagem?: string;
  diasPossiveis?: number[];
}

export class AgendamentoDeProdutos {

  static avalieAdicao(pedido: any, produto: any, catalogo: any, agora: Date = new Date()): AvaliacaoAdicao {
    const dataAgendada: Date = pedido && pedido.obtenhaDataHoraAgendada ? pedido.obtenhaDataHoraAgendada() : null;
    const restrito = RegrasDeAgendamentoDeProduto.temRestricaoDeDia(produto);

    if(dataAgendada) {
      const disponivelNaData = pedido.horarioEntrega ?
        RegrasDeAgendamentoDeProduto.disponivelNaDataHora(produto, catalogo, dataAgendada) :
        RegrasDeAgendamentoDeProduto.disponivelNoDia(produto, catalogo, dataAgendada);

      if(disponivelNaData) return {acao: 'adicionar'};

      const itens = (pedido.itens || []).map((item: any) => item.produto).filter((p: any) => !!p);
      const diasPossiveis = RegrasDeAgendamentoDeProduto.diasEmComum([...itens, produto], catalogo) || [];
      const descricaoProduto = RegrasDeAgendamentoDeProduto.descreva(produto, catalogo);
      const diaAgendado = RegrasDeAgendamentoDeProduto.NOMES_DOS_DIAS[dataAgendada.getDay()];

      if(diasPossiveis.length)
        return {
          acao: 'trocarData',
          diasPossiveis,
          mensagem: `"${produto.nome}" só está disponível ${descricaoProduto}, e sua sacola está agendada para ${diaAgendado}. ` +
            `Para levar os dois, o pedido inteiro precisa ir ${RegrasDeAgendamentoDeProduto.descrevaDias(diasPossiveis)}.`
        };

      return {
        acao: 'incompativel',
        diasPossiveis,
        mensagem: `"${produto.nome}" só está disponível ${descricaoProduto} e não combina com os dias dos itens que já estão na sacola. ` +
          `Finalize este pedido e faça outro para ele.`
      };
    }

    if(!restrito || produto.agendavel === false) return {acao: 'adicionar'};

    // produto restrito: se vale agora entra normal; senão precisa agendar
    if(RegrasDeAgendamentoDeProduto.disponivelNaDataHora(produto, catalogo, agora)) return {acao: 'adicionar'};

    return {acao: 'agendar'};
  }

  /** "sábado, 12/09 às 12:00" */
  static descrevaAgendamento(dataEntrega: Date, horarioEntrega: any): string {
    if(!dataEntrega) return '';

    const dia = RegrasDeAgendamentoDeProduto.NOMES_DOS_DIAS[dataEntrega.getDay()];
    const dd = String(dataEntrega.getDate()).padStart(2, '0');
    const mm = String(dataEntrega.getMonth() + 1).padStart(2, '0');
    const texto = `${dia}, ${dd}/${mm}`;

    return horarioEntrega ? `${texto} às ${horarioEntrega}` : texto;
  }
}
